module.exports = __webpack_public_path__ + "static/media/muzzle-flash-png.6f4bd138.svg";